import script from "./rsvpWithKehadiran.vue?vue&type=script&setup=true&lang=js"
export * from "./rsvpWithKehadiran.vue?vue&type=script&setup=true&lang=js"

import "./rsvpWithKehadiran.vue?vue&type=style&index=0&id=3c229037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c229037"]])

export default __exports__